<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-08-03 15:59:54
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterPropertyGroup\editRosterPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_RosterPropertyGroup_form_editTitle')
        : $t('label_essweb_RosterPropertyGroup_form_viewTitle')
    "
    pad="0"
    widthClass="max-1000"
    delBtn
    :editBtn="!iSEdited"
    :initData="RosterPGData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'roster_property_group_name',
      'roster_property_group_description',
      'roster_property_group_code',
      'remarks',
    ]"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_RosterPropertyGroup_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                <v-switch
                  color="primary"
                  :disabled="!iSEdited"
                  class="ml-4"
                  v-model="RosterPGData.is_default"
                  :label="RosterPGData.is_default ? 'Default' : ''"
                ></v-switch>
              </v-col> -->
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="RosterPGData.roster_property_group_name"
                  @change="
                    (valueArr) => {
                      RosterPGData.roster_property_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterPropertyGroup_form_rosterPropertyGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="RosterPGData.roster_property_group_description"
                  @change="
                    (valueArr) => {
                      RosterPGData.roster_property_group_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_RosterPropertyGroup_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="
                    $t(
                      'label_essweb_RosterPropertyGroup_form_rosterPropertyGroupCodeLabel'
                    )
                  "
                  v-model="RosterPGData.roster_property_group_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_RosterPropertyGroup_form_Remark")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  v-model="RosterPGData.remarks"
                  dense
                  counter="500"
                  :filled="iSEdited"
                  single-line
                  :disabled="!iSEdited"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            :listdata="PropertyListData"
            @edit="
              (obj) => {
                viewProperty = false;
                toEditProperty(obj);
              }
            "
            @view="
              (obj) => {
                viewProperty = true;
                toEditProperty(obj);
              }
            "
            :canEdit="iSEdited"
          />
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup4
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="$route.params.id"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import EditMappingPopup4 from "@/Page/EssAdmin/Roster/RosterPropertyGroup/components/EditMappingPopup4";
export default {
  name: "editRosterPG",
  components: { EditMappingPopup4 },
  computed: {
    ...mapGetters(["companyLang", "defaultUTC"]),
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_RosterPropertyGroup_form_step_generalLabel",
        "label_essweb_RosterPropertyGroup_form_step_propertyGroupLabel",
      ],
      showMappingPopup: false,
      PropertyListData: null,
      viewProperty: false,
      PropertyData: null,
      RosterPGData: {
        roster_property_group_name: "",
        roster_property_group_description: "",
        roster_property_group_code: "",
        uuid: "",
        remarks: "",
      },
      desserts: [],
    };
  },
  watch: {},
  mounted() {
    // this.RosterPGData.roster_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.RosterPGData.roster_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getDetail();
    this.getPorpertyList();
  },
  methods: {
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["roster_property_group_name_save"] =
          res.data.roster_property_group_name;
        res.data.roster_property_group_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.roster_property_group_name
        );
        res.data["roster_property_group_description_save"] =
          res.data.roster_property_group_description;
        res.data.roster_property_group_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.roster_property_group_description
          );
        this.RosterPGData = res.data;
      });
    },
    onEditProperty: function (obj, deleteArr, changeList) {
      const that = this;

      this.PropertyData = null;
      // obj["changeList"].map((item) => (item["org_level_uuid"] = "002"));
      that.showMappingPopup = false;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property",
        url: "/roster-property-group/update/",
        data: {
          uuid: this.$route.params.id,
          property_ids: deleteArr.length ? deleteArr.join(",") : "",
          ess_att_roster_property: changeList,
        },
      }).then((res) => {
        that.findTreeItem(that.desserts, obj.property_master_code, changeList);
      });
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property",
        url: "/roster-property/get-list/",
        data: {
          roster_property_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toBack: function () {
      // if (this.iSEdited) {
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/update/",
        data: {
          uuid: this.$route.params.id,
          roster_property_group_name: this.$transCommonLangKey(
            this.RosterPGData.roster_property_group_name,
            this.RosterPGData.roster_property_group_name_save
          ),
          roster_property_group_description: this.$transCommonLangKey(
            this.RosterPGData.roster_property_group_description,
            this.RosterPGData.roster_property_group_description_save
          ),
          roster_property_group_code:
            this.RosterPGData.roster_property_group_code,
          remarks: this.RosterPGData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterPropertyGroup_list_updateRosterPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterPropertyGroup_list_deleteRosterPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
